import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MyScrollView from '../../components/MyScrollView';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';
import AdditionalDetailsForm from '../../components/register/AdditionalDetailsForm';
import Header from '../../components/register/Header';
import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import { capitalize } from '../../utils/stringFunctions';

const styles = StyleSheet.create({
  containerStyle: {
    backgroundColor: Colors.mediumBlue,
  },
  contentContainerStyle: {
    ...Layout.formContentContainer,
  },
  centerContainer: {
    flex: 1,
    backgroundColor: Colors.white,
    alignItems: 'center',
    maxWidth: 720,
    width: '100%',
  },
  welcomeContainer: {
    alignItems: 'center',
    backgroundColor: Colors.backgroundBlue,
    maxWidth: Layout.mobile - 200,
    width: '100%',
  },
  welcomeImage: {
    height: 184,
    width: '100%',
    resizeMode: 'contain',
    marginTop: 3,
  },
  getStartedContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    maxWidth: Layout.mobile - 200,
    width: '100%',
  },
});

class AdditionalDetailsScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('FamilyDetails');
  };

  goNext = (data) => {
    const { actions, navigation } = this.props;
    data.onboarding_complete = true;
    actions.updateUser(data);
    navigation.navigate('AccountCreated');
  };

  render() {
    const { registration, actions } = this.props;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];
    const additionalDetails = translation.additional_details;

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <MyScrollView
            containerStyle={styles.containerStyle}
            contentContainerStyle={styles.contentContainerStyle}
          >
            <Header title={capitalize(additionalDetails)} goBack={this.goBack} />
            <View style={styles.centerContainer}>
              <View style={styles.welcomeContainer}>
                <Image
                  source={require('../../assets/images/additional_details.png')}
                  style={styles.welcomeImage}
                />
              </View>
              <View style={styles.getStartedContainer}>
                <AdditionalDetailsForm
                  translation={translation}
                  goBack={this.goBack}
                  goNext={this.goNext}
                  registration={registration}
                  actions={actions}
                />
              </View>
            </View>
          </MyScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDetailsScreen);
